import { render, staticRenderFns } from "./PersonalInfoFormContainer.vue?vue&type=template&id=01042c3c&"
import script from "./PersonalInfoFormContainer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PersonalInfoFormContainer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports